export const ONBOARDING_VIDEO_ID = 'skBCr048y9M';

export const SIDE_NAV_WIDTH = {
  EXPANDED: '240px',
  COLLAPSED: '60px',
};

export const LARGE_SCREEN_WIDTH = '700px';

export const WORKSPACE_ROUTES = {
  HOME: '/home',
  DASH: '/dash',
  TEAM_CARDS: '/cards/team',
  EMAIL_SIGNATURES: '/email-signatures',
  VIRTUAL_BACKGROUNDS: '/virtual-backgrounds',
  ACCESSORIES: '/accessories',
  CAMPAIGNS: '/campaigns',
  CONTACTS: '/contacts',
  WORKSPACE_SETTINGS: '/workspace-settings',
  TEAM_MEMBERS: '/team-members',
  TEMPLATES: '/cards/templates',
  SETTINGS: {
    BILLING_AND_SUBSCRIPTION: '/settings/billing-and-subscription',
    PERSONAL_DETAILS: '/settings/personal-details',
    SECURITY: '/settings/security',
  },
  PERSONAL_CARDS: '/cards/personal',
  LIST_ENRICHMENT: '/bulk-enrichment',
};
